// TwoColumnTextBox.js
import React from 'react';
import DOMPurify from 'dompurify';

const TwoColumnTextBox = ({ backgroundColor = '', leftHeadline = '', leftBody = '', rightHeadline = '', rightBody = ''}) => (
	<div className={`c-teaser c-teaser--vertical-50-50 ${backgroundColor}`}>
		<div className="l-grid l-grid--max-width u-padding-none">
			<div className="c-teaser__link-area" aria-label="More information about short description of teaser content">
				<div className="c-teaser__content">
					{leftHeadline && (
						<h3 className="c-heading c-teaser__content__headline u-text-weight-light u-text-small-center-down"
							dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(leftHeadline) }}>
						</h3>
					)}
					{leftBody && (
						<div
							dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(leftBody) }}
						/>
					)}
				</div>
				<div className="c-teaser__content">
					{rightHeadline && (
							<h3 className="c-heading c-teaser__content__headline u-text-weight-light u-text-small-center-down"
								dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(rightHeadline) }}>
							</h3>
						)}
					{rightBody && (
						<div
							dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(rightBody) }}
						/>
					)}
				</div>
			</div>
		</div>
	</div>
);

export default TwoColumnTextBox;
